<template>
  <div class="pageContainer">
    <PaperNavigate v-if="step !== 4" />
    <ScoringStandard v-if="step === 2" />
    <SendScoreBoard v-else-if="step === 3" />
    <FinishNotice v-else-if="step === 4" />
    <UploadEvaluationPaper v-else />
    <Modal v-if="isShow" />
  </div>
</template>

<script>
import PaperNavigate from '@/components/Peer/ScoringPaper/PaperNavigate.vue';
import UploadEvaluationPaper from '@/components/Peer/ScoringPaper/UploadEvaluationPaper/UploadEvaluationPaper.vue';
import ScoringStandard from '@/components/Peer/ScoringPaper/ScoringStandard.vue';
import SendScoreBoard from '@/components/Peer/ScoringPaper/SendScoreBoard.vue';
import FinishNotice from '@/components/Peer/ScoringPaper/FinishNotice.vue';
import Modal from '@/components/Modal.vue';
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'ScoringPaper',
  components: {
    PaperNavigate,
    UploadEvaluationPaper,
    ScoringStandard,
    SendScoreBoard,
    FinishNotice,
    Modal,
  },
  data() {
    return {
      part: 1,
      nextDisabled: true,
      title: '',
      numberEvaluations: 0,
    };
  },
  methods: {
    ...mapActions('peerPaper', ['AC_INIT_PAPER']),
    ...mapActions('modal', ['AC_MODAL_OPEN', 'AC_MODAL_CONTENT_SETTING']),
  },
  computed: {
    ...mapGetters('peerPaper', ['GE_FORM_DATA', 'GE_PAPER_QUESTIONS']),
    ...mapState('peerPaper', {
      paperOriginData: (state) => state.paperOriginData,
      step: (state) => state.evaluationStep,
    }),
    ...mapState('modal', ['isShow']),
    ...mapState('login', ['isLogin']),
  },
  created() {
    let content;
    let url;

    if (!this.isLogin) {
      content =
        this.$i18n.locale === 'eng' ? 'Please sign in to use.' : '로그인이 필요한 서비스입니다.';
      url = '/login';
      this.AC_MODAL_OPEN({
        content: content,
        url: url,
      });
    }

    if (this.paperOriginData) {
      this.AC_INIT_PAPER();
    }
  },
};
</script>

<style lang="scss" scoped>
.pageContainer {
  height: 100%;
}
</style>
